import { locForGetClientConfig } from "@/models/localForage/localForage.model";
type Theme = {
  [key: string]: string;
};

export async function applyStyles() {
  try {
    const clientConfig = await locForGetClientConfig();

    if (!clientConfig) {
      return;
    }

    setGlobalColorTheme(clientConfig.cssVariables);
  } catch (error) {
    console.error("Error applying styles", error);
  }
}

export function setGlobalColorTheme(theme: Theme) {
  try {
    if (!theme || Object.keys(theme).length === 0) {
      document.documentElement.style.cssText = "";
      return;
    }

    for (const key in theme) {
      const value = theme[key];
      document.documentElement.style.setProperty(`${key}`, `${value}`);
    }
  } catch (error) {
    console.log("Error setting global color theme", error);
  }
}
